<template>
    <div class="mb-1 mx-1 me-1" :style="Skin.animation.frame" style="overflow:hidden;">
      <div :style="Skin.animation.header" class="" style="padding: 5px;">
          <span :style="Skin.animation.header_text">{{ translate("live") }}</span>
      </div>
      <div class="tab-content" id="pills-tabContent">
          <div
              class="tab-pane fade view active show"
              id="pills-field"
              role="tabpanel"
              aria-labelledby="pills-field"
          >
              <div class="responsive-container">
                  <iframe id="visIframe" scrolling="no" frameborder="0" allowfullscreen="" :src="widget_url" class="matchStreamingIframe" style="opacity: 1;"></iframe>
              </div>
          </div>
          <div
              class="p-2 tab-pane fade view"
              id="pills-streaming"
              role="tabpanel"
              aria-labelledby="pills-streaming"
          >
                <div class="responsive-container" v-if="actualTab === 'streaming'">
                  <iframe v-if="user.token !== ''" id="visIframe" scrolling="no" frameborder="0" allowfullscreen="" :src="streamingUrl" class="matchStreamingIframe" style="opacity: 1;"></iframe>
                  <iframe v-else :srcdoc="htmlStreamingNotAllowed()" frameborder="0"></iframe>
              </div>
          </div>
          <div
              class="p-2 tab-pane fade view"
              id="pills-stats"
              role="tabpanel"
              aria-labelledby="pills-stats"
              style="max-height:15vw;overflow:auto;"
          >
              <stats-progress
                  v-for="(stat, key) in gameData.stats"
                  v-bind:key="key + 'content'"
                  :indice="key" 
                  :skin="Skin" 
                  :team1_value="stat.team1_value==null?0:stat.team1_value"
                  :team2_value="stat.team2_value==null?0:stat.team2_value"
                  :tittle_stat="translate(key+'_stat')"
              />
          </div>
      </div>
      
     <div :style="nav_active">
      <div>
          <ul class="nav px-1" :style="Skin.animation.navigation_fondo">
              <li 
                  id="field" 
                  class="nav-item me-3 option nav_active"
                  data-bs-toggle="pill"
                  :data-bs-target="'#pills-field'"
                  role="tab"
                  :aria-controls="'pills-field'"
                  aria-selected="true"
                  @click="select_view('field')" 
              >
                  <div class="p-1" style="width:30px;cursor:pointer">
                      <svg :fill="Skin.animation.navigation_text" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" class="sr-tabs-tab__icon"><path fill-rule="nonzero" d="M17 2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16ZM8.5 3H1v2.5h2.5v7H1V15h7.5v-3.55a2.5 2.5 0 0 1 0-4.9V3ZM17 3H9.5v3.55a2.5 2.5 0 0 1 0 4.9V15H17v-2.5h-2.5v-7H17V3Zm0 3.5h-1.5v5H17v-5Zm-14.5 0H1v5h1.5v-5Zm6 1.09a1.5 1.5 0 0 0 0 2.82V7.6Zm1 0v2.82a1.5 1.5 0 0 0 0-2.82Z"></path></svg>
                  </div>
              </li>
              <li 
                  id="streaming" 
                  class="nav-item me-3 option"
                  data-bs-toggle="pill"
                  :data-bs-target="'#pills-streaming'"
                  role="tab"
                  :aria-controls="'pills-streaming'"
                  aria-selected="false"
                  @click="select_view('streaming')" 
                  v-if="streamingUrl !== ''"
              >
                  <div class="p-1" style="width:30px;cursor:pointer">
                    <svg data-v-00847bf4="" width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#ffffff"><g data-v-00847bf4="" id="SVGRepo_bgCarrier" stroke-width="0"></g><g data-v-00847bf4="" id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g data-v-00847bf4="" id="SVGRepo_iconCarrier"><path data-v-00847bf4="" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 7h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h7zm0 0L8 3m4 4 4-4"></path></g></svg>
                  </div>
              </li>
              <li 
                  id="stats" 
                  class="nav-item me-3 option"
                  data-bs-toggle="pill"
                  :data-bs-target="'#pills-stats'"
                  role="tab"
                  :aria-controls="'pills-stats'"
                  aria-selected="false"
                  @click="select_view('stats')" 
              >
                  <div class="p-1" style="width:30px;cursor:pointer">
                      <svg :fill="Skin.animation.navigation_text" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" class="sr-tabs-tab__icon"><path d="M4.636 9.912H1.727A.728.728 0 0 0 1 10.64v6.631c0 .403.326.729.727.729h2.91a.728.728 0 0 0 .727-.729v-6.63a.728.728 0 0 0-.728-.73Zm-.727 6.63H2.455V11.37h1.454v5.174ZM10.455 0h-2.91a.728.728 0 0 0-.727.729V17.27c0 .403.326.729.727.729h2.91a.728.728 0 0 0 .727-.729V.73A.728.728 0 0 0 10.455 0Zm-.728 16.543H8.273V1.457h1.454v15.086Zm6.546-11.675h-2.91a.728.728 0 0 0-.727.728v11.675c0 .403.326.729.728.729h2.909a.728.728 0 0 0 .727-.729V5.596a.728.728 0 0 0-.727-.728Zm-.728 11.675h-1.454V6.325h1.454v10.218Z" fill-rule="nonzero"></path></svg>
                  </div>
              </li>
          </ul>
      </div>
      </div>
    </div>
  </template>
  
  <script>
  import statsProgress from './stats_progress.vue'
  export default {
      name: 'animation',
      props:['Skin','translation','language'],
      components:{
          statsProgress
      },
      data(){
          return {
            actualTab: 'field',
              langsKeys:{
                  "es":"spa",
                  "en":"eng",
                  "pt":"por",
                  "ru":"rus",
                  "tr":"tur",
                  "de":"ger",
                  "fr":"fra",
                  "it":"ita",
                  "zh":"chi",
                  "ja":"jpn",
              }
          }
      },
      computed: {
            streamingUrl(){
                // const events = this.$store.getters['getGamesCanchaData'];
                const events = this.$store.getters['getGamesTvData'];
                if(this.$store.getters['live/getLiveEvent'].data){
                    let data = this.$store.getters['live/getLiveEvent'].data.data.sport || {};
                    if(Object.keys(data).length>0){
                        let sport = Object.keys(data)[0];
                        let region_idx = Object.keys(data[sport].region)[0];
                        let league_idx = Object.keys(data[sport].region[region_idx].competition)[0];
                        let game_idx = Object.keys(data[sport].region[region_idx].competition[league_idx].game)[0];
                        let streamingUrl = '';
                        events?.forEach((event) => {
                            if(event.betconstructId == game_idx){
                                // streamingUrl = event.stream_iframe_url;
                                streamingUrl = event.streamUrl[0];

                            }
                        });
                        return streamingUrl;   
                    }
                }
                return '';
            },
            user(){
                return this.$store.getters['getUserData'];
            },
          widget_url(){
              if(this.$store.getters['live/getLiveEvent'].data){
                  let data = this.$store.getters['live/getLiveEvent'].data.data.sport || {};
                  if(Object.keys(data).length>0){
                      let sport = Object.keys(data)[0];
                      let region_idx = Object.keys(data[sport].region)[0];
                      let league_idx = Object.keys(data[sport].region[region_idx].competition)[0];
                      let game_idx = Object.keys(data[sport].region[region_idx].competition[league_idx].game)[0];
                      return `https://widget-sports.jbets.online/?matchID=${game_idx}&partnerID=784929910940820&language=${this.langsKeys[this.$props.language]}`;   
                  }
              }
              return '';
          },
          gameData() {
              if (this.$store.getters['live/getLiveEvent'].data) {
                  let data = this.$store.getters['live/getLiveEvent'].data.data.sport || {};
                  if (Object.keys(data).length > 0) {
                      let sport = Object.keys(data)[0];
                      let region_idx = Object.keys(data[sport].region)[0];
                      let league_idx = Object.keys(data[sport].region[region_idx].competition)[0];
                      let game_idx = Object.keys(data[sport].region[region_idx].competition[league_idx].game)[0];
                      if (data[sport].region[region_idx].competition[league_idx].game[game_idx]) {
                          return {
                              stats: data[sport].region[region_idx].competition[league_idx].game[game_idx].stats,
                          }
                      }
                  }
              }
              return false;
          },
          nav_active(){
              return {
                  '--nav-active-color':this.$props.Skin.animation.nav_active_color,
                  '--nav-active-bar':this.$props.Skin.animation.nav_active_bar
              };
          }
      },
      methods:{
        htmlStreamingNotAllowed(){
            return  '<div><div style="color: #ffffff; font-size: 16px; text-align: center; padding-top: 20px; font-family: Arial, Helvetica, sans-serif;">'+this.translate('streaming_not_allowed')+'</div></div>'
        },
          translate(text){
              if(this.$props.translation[text]){
                  return this.$props.translation[text][this.$props.language];
              }
              return text.split('_stat')[0];
          },
          select_view(id){
            this.actualTab = id;
              var all = document.getElementsByClassName("option");
              var all2 = document.getElementsByClassName("view");
              [...all].forEach((element) => {
                  element.classList.remove('nav_active');
                  element.classList.remove('active');
              });
              [...all2].forEach((element) => {
                  element.classList.remove('show');
              });
              document.getElementById(id).classList.add('nav_active');
              document.getElementById(id).classList.add('active');
              document.getElementById('pills-'+id).classList.add('show');
          }
      }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  @import '../../../../assets/animation.css?v=1';
  .long_text {
      display: -webkit-box;
      max-width: 200px;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
  }
  .audio-icon {
      position: absolute;
      right: 0px;
      top: 0px;
      color: azure;
      cursor: pointer;
  }
  .nav_active{
      color:var(--nav-active-color);
      border-bottom: var(--nav-active-bar);
  }
  .responsive-container {
      position: relative;
      width: 100%; /* Ancho completo */
      padding-top: 61%; /* Mantiene la relación 2:1 (850 / 1700 * 100) */
      overflow: hidden; /* Para evitar desbordamiento */
    }
  
    .responsive-container iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover; /* Ajusta la imagen para llenar el espacio */
    }
  </style>
  